import { ReactNode } from 'react';

import { ContentNode, ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';

import { translationKeys } from '../translations';
import { useVideoConsultationGlobalState } from '../shared/useVideoConsultationGlobalState';

type VideoConsultationEndShowEventInterceptorProps = {
   readonly appointmentId: number;
   readonly children: ReactNode;
   readonly content: ContentNode;
};

export const VideoConsultationEndShowEventInterceptor = (
   props: VideoConsultationEndShowEventInterceptorProps
): JSX.Element => {
   const { state, hangUp } = useVideoConsultationGlobalState();

   return (
      <ShowModalEventInterceptor
         testId={'videoConsultationEnd'}
         shouldShowModal={state.type === 'inCall' && state.originId === props.appointmentId}
         title={translationKeys.videoConsultationInProgress}
         confirmationButtonLabel={translationKeys.approveAndEndVideoConsultation}
         content={props.content}
         onConfirm={(resolve) => {
            hangUp();
            resolve();
         }}
         modalWidth={ModalWidth.NORMAL}
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
